import { render, staticRenderFns } from "./GuaranteeOnboardingGeneralData.vue?vue&type=template&id=4d0c96cc&scoped=true&"
import script from "./GuaranteeOnboardingGeneralData.vue?vue&type=script&lang=js&"
export * from "./GuaranteeOnboardingGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c96cc",
  null
  
)

export default component.exports